var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideNavMapIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4C7.94444 4 6.88889 4.33333 6 5L3.8 6.65C3.29639 7.02771 3 7.62049 3 8.25V16.879C3 18.474 4.82083 19.3844 6.09677 18.4274C6.95699 17.7823 7.97849 17.4597 9 17.4597M9 4C10.0556 4 11.1111 4.33333 12 5L12.0968 5.07258C12.957 5.71774 13.9785 6.04032 15 6.04032M9 4V4.75V16.75V17.4597M15 6.04032C16.0215 6.04032 17.043 5.71774 17.9032 5.07258C19.1792 4.11562 21 5.02604 21 6.62097V15.25C21 15.8795 20.7036 16.4723 20.2 16.85L18 18.5C17.1111 19.1667 16.0556 19.5 15 19.5M15 6.04032V6.75V18.75V19.5M15 19.5C13.9444 19.5 12.8889 19.1667 12 18.5L11.9032 18.4274C11.043 17.7823 10.0215 17.4597 9 17.4597",
    stroke: "#53545C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideNavMapIcon);
export default __webpack_public_path__ + "static/media/SideNavMapIcon.3eee5ad4d9ffb22942c29dc841095191.svg";
export { ForwardRef as ReactComponent };